import { Link } from 'react-router-dom';
import React from 'react';

import { AddIcon, Button, Page, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { useIsUserPermittedTo } from '@occc/utils-access-control';
import { Feature } from '@occc/utils-access-control';

import { breadcrumbLinks } from './messaging-campaigns-list.constants';
import { MessagingCampaignsTableContainer } from './messaging-campaigns-table.container';

import { routeCreator } from '../../messaging-center.utils';
import { PAGE_SUBTITLE, CAMPAIGN_LIST_PAGE_TITLE } from '../../messaging-center.constants';
import { CREATE_BUTTON_TITLE } from '../messaging-campaign-create/messaging-campaign-create.constants';

export const MessagingCampaignsListPage = () => {
  useAppLayoutContextConsumer(breadcrumbLinks);

  const isUserPermittedToCreate = useIsUserPermittedTo(Feature.MESSAGING_CENTER_CREATE);

  return (
    <Page
      browserTabTitle={CAMPAIGN_LIST_PAGE_TITLE}
      pageHeaderProps={{
        title: CAMPAIGN_LIST_PAGE_TITLE,
        subtitle: PAGE_SUBTITLE,
      }}
      actions={
        isUserPermittedToCreate && (
          <Button
            color='secondary'
            variant='contained'
            component={Link}
            to={routeCreator.campaignCreate()}
            startIcon={<AddIcon />}
            role='button'
          >
            {CREATE_BUTTON_TITLE}
          </Button>
        )
      }
    >
      <MessagingCampaignsTableContainer />
    </Page>
  );
};
